export default () => {
  $('.init-select2').each(function(index, element) {
    $(element).select2({
      minimumResultsForSearch: -1,
      dropdownParent: $(element).parents('.select2-parent')
    });
  })
  // $('.js-select-label .init-select2').on('select2:select', function (e) {
  //   var data = e.params.data;
  //   if (data.element.value !== "") {
  //     $(this).parents(".js-input-parent").addClass('active');
  //   } else {
  //     $(this).parents(".js-input-parent").removeClass('active');
  //   }
  // });
}


// WEBPACK FOOTER //
// app/scripts/components/select2.js